/*
 * MDB shim for Row
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/InlineTable.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Activities/activities-list.jsx
 * - src/Seating/Activities/activitiesModal.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Filters/UserFilters.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Orders/RecurringOrders.jsx
 * - src/Seating/Orders/collectionsView.jsx
 * - src/Seating/Orders/orderList.jsx
 * - src/Seating/Orders/salesPipelineView.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/createNoteModal.jsx
 * - src/Seating/Patient/PatientViewComponents/patientInformationTab.jsx
 * - src/Seating/Patient/PatientViewComponents/pverifyModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Reports/reports.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUIBox from "@mui/material/Box";

export default function Row({ children, className, style, ...rest }) {
    return (
        <MUIBox className={className} style={{ display: "flex", flexWrap: "wrap", ...style }} {...rest}>
            {children}
        </MUIBox>
    );
}
